import { getIdAndEmitterTypeFromZoneEmitterTypeKey } from 'App/Map/_utils/irrigationZoneEmitterTypeKeyUtil'
import type { TIrrigationZoneEmitterId } from 'stores/fieldAssetStore/helperTypes'

export const checkIfDuplicateEmitters = (emitters: TIrrigationZoneEmitterId[]) => {
  const emitterTypes = emitters.map((emitter) => {
    return getIdAndEmitterTypeFromZoneEmitterTypeKey(emitter).emitterType
  })

  return new Set(emitterTypes).size !== emitterTypes.length
}
